import { SET_ACTIVE_COLLAPSE, SET_ACTIVE_LINK } from '../ActionTypes.js';

const initialState = {
    activeTab: '1',
    activeLink: 'devOps',
    activeCollapse: 600,
};

const viewReduction = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACTIVE_COLLAPSE:
            return {
                ...state,
                activeCollapse: action.payload,
            };
        case SET_ACTIVE_LINK:
            return {
                ...state,
                activeLink: action.payload,
            };
        default:
            return state;
    }
};

export default viewReduction;
